import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

import moment from 'moment';
declare var require: any

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit {

  actions : any;
  filter : any;
  view : any;
  group : any;
  worker_id : any;
  user_id : any;
  selected : any;
  search : any;
  sort = 'newest';

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };

    this.worker_id=null;

    this.getActions();

  }

  getActions(){

    this.updateFilter();

    //console.log('filter', this.filter);

    this.okService.get("reports/actions",this.filter)
    .subscribe((data) => {

      this.actions = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

      //console.log("actions",data);

    });


  }

  changePage(){
    //console.log('page',this.okService.pagination.page);
    this.getActions();
  }

  updateFilter(){

    this.filter = [];
    this.filter['start'] = this.selected.startDate.format("YYYY-MM-DD");
    this.filter['end'] = this.selected.endDate.format("YYYY-MM-DD");
    this.filter['page'] = this.pagination.page;

    if(this.search){
      this.filter['search'] = this.search;
    }

    if(this.worker_id){
      this.filter['worker_id'] = this.worker_id;
    }

    if(this.group){
      this.filter['group'] = this.group;
    }

    if(this.user_id){
      this.filter['user_id'] = this.user_id;
    }
    //console.log('updateFilter',this.filter);
  }

  hasFilter(){
    return this.search || this.worker_id || this.user_id || this.group
  }

  clearFilter(){

    this.filter = [];
    this.getActions();

  }

  export(){

    this.updateFilter();

    //console.log('export filter',this.filter);

    this.okService.download("reports/actionsexport",this.filter);
  }
}
